var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithlessLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 66,
    viewBox: "0 0 220 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.7202 43.5253H87.4456L91.5041 30.0027L95.5626 43.5253H99.2879L106.163 22.1195H101.469L97.3798 35.5512L93.3819 22.1195H89.6565L85.6586 35.5209L81.5698 22.1195H76.845L83.7202 43.5253Z",
    fill: "#07132B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.896 26.3563V43.5254H112.651V26.3563H107.896Z",
    fill: "#07132B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.172 22.1195H114.475V26.2733H121.169V43.5253H125.924V26.2733H132.618V22.1195H125.921V26.2726H121.172V22.1195Z",
    fill: "#07132B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.441 43.5253H139.197V34.581H147.677V43.5253H152.462V22.1195H147.677V30.4575H139.197V22.1195H134.441V43.5253Z",
    fill: "#07132B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.71 39.3424H160.464V43.5253H169.945V39.3412H160.465V22.1195H155.71V39.3424Z",
    fill: "#07132B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.216 43.5253L176.611 43.5253V39.4067H171.86V22.1195H187.064V26.2127H176.615V30.6091H186.156V34.581H176.615V39.4018H187.216V43.5253Z",
    fill: "#07132B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.521 43.8589C200.67 43.8589 203.729 41.403 203.729 37.3098C203.729 29.5176 193.704 31.3671 193.704 27.6377C193.704 26.4553 194.704 25.8186 196.4 25.8186C198.035 25.8186 199.307 26.4553 200.579 27.7893L203.669 24.727C202.063 22.9382 199.489 21.786 196.49 21.786C192.069 21.786 188.979 24.151 188.979 28.0925C188.979 35.6119 199.004 33.7017 199.004 37.7343C199.004 39.0077 197.823 39.796 195.824 39.796C193.583 39.796 191.978 38.9167 190.615 37.3098L187.525 40.3721C189.615 42.737 192.008 43.8589 195.521 43.8589Z",
    fill: "#07132B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.792 43.8589C216.941 43.8589 220 41.403 220 37.3098C220 29.5176 209.975 31.3671 209.975 27.6377C209.975 26.4553 210.975 25.8186 212.671 25.8186C214.306 25.8186 215.578 26.4553 216.85 27.7893L219.94 24.727C218.334 22.9382 215.76 21.786 212.761 21.786C208.339 21.786 205.25 24.151 205.25 28.0925C205.25 35.6119 215.275 33.7017 215.275 37.7343C215.275 39.0077 214.094 39.796 212.095 39.796C209.854 39.796 208.249 38.9167 206.886 37.3098L203.796 40.3721C205.886 42.737 208.279 43.8589 211.792 43.8589Z",
    fill: "#07132B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.9646,
    y: 16.335,
    width: 32.9647,
    height: 13.2,
    fill: "#32DCDC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 36.1969,
    width: 32.9647,
    height: 13.2,
    fill: "#3AF2AE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4824,
    y: 33,
    width: 33,
    height: 13.1859,
    transform: "rotate(-90 16.4824 33)",
    fill: "#40B0D5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2612,
    y: 66,
    width: 33,
    height: 13.1859,
    transform: "rotate(-90 36.2612 66)",
    fill: "#5CFFE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithlessLogo);
export default __webpack_public_path__ + "static/media/withless-logo.c4ee8b296f407e48e51e37ab0603755b.svg";
export { ForwardRef as ReactComponent };